import axios from "./axios";

class PostRepository {
  get(page, category, month, year) {
    return axios
      .get(`/posts`, {
        params: {
          page: page,
          category: category,
          month: month,
          year: year,
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  recent() {
    return axios.get(`/recentposts`).then((response) => {
      return response.data;
    });
  }

  archives() {
    return axios.get(`/archives`).then((response) => {
      return response.data;
    });
  }

  create(post) {
    return axios.post(`/posts`, post).then((response) => {
      return response.data;
    });
  }

  update(post) {
    return axios.put(`/posts/${post.id}`, post).then((response) => {
      return response.data;
    });
  }

  save(post) {
    if (!post.id) return this.create(post);
    else return this.update(post);
  }

  getOne(id) {
    return axios.get(`/posts/${id}`).then((response) => {
      return response.data;
    });
  }
}

export default new PostRepository();



// WEBPACK FOOTER //
// ./src/data/post.repository.js